import * as React from "react";
import { getAccessRegistry } from "@/lib/auth/AccessRegistry";
import type { Policy } from "@/lib/auth/AccessPolicy";

/**
 * React hook to read the current access Policy and re-render on updates.
 * Components should depend on this instead of raw backend limitation keys.
 */
export function useAccessPolicy(): Policy {
  const registry = React.useMemo(() => getAccessRegistry(), []);
  const [, force] = React.useReducer((x: number) => x + 1, 0);

  React.useEffect(() => {
    return registry.subscribe(() => force());
  }, [registry]);

  return registry.getPolicy();
}

/** Convenience helpers */
export function useCanReadRecords() {
  return useAccessPolicy().records.read;
}

export function useCanCreateRecords() {
  return useAccessPolicy().records.create;
}
